import { render, staticRenderFns, recyclableRender, components } from "./pageHeader.vue?vue&type=template&id=14998377&scoped=true&"
var renderjs
import script from "./pageHeader.vue?vue&type=script&lang=js&"
export * from "./pageHeader.vue?vue&type=script&lang=js&"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=14998377&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14998377",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/pageHeader.vue"
export default component.exports